import { ICategoryInfo } from '@gem/models/commonModel';

import { getAllCategoriesInfo } from '../getAllCategoriesInfo/getAllCategoriesInfo';

export const getCategoryInfoById = async (id: string): Promise<ICategoryInfo | null> => {
  const categories = await getAllCategoriesInfo();
  return categories.find((category) => category.id.toString() === id) || null;
};
